import { FormControl } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { TipoParametro } from 'src/app/features/data-visualization/reports/models/parametro';
import { CustomInput } from './custom-input';
import { HelperFunctions } from 'src/app/util/util-functions';

@Component({
  selector: 'app-type-input',
  templateUrl: './type-input.component.html',
  styleUrls: ['./type-input.component.scss']
})
export class TypeInputComponent {
  @Input() control: FormControl;
  @Input() input: CustomInput;
  parameterType: typeof TipoParametro = TipoParametro;

  /**
   * A function that checks if the control is invalid
   * @returns {boolean}
   */
  hasErrors(): boolean {
    return HelperFunctions.controlIsInvalid(this.control);
  }
}